module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch3_20210921105649_T.b346c017.jpg";